export default __webpack_public_path__ + "static/why-ml-10--mobile-5a789d080f87d9eabe9c0073c4d17de8.webp";